import { Component, effect, inject, OnInit } from '@angular/core';
import { GlobalsStore } from '../../../stores/globals.state';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { Commune, LineConfiguration } from '../../../models/commune';
import { CheckboxModule } from 'primeng/checkbox';
import { NgIf } from '@angular/common';
import { NgxSliderComponent } from '../../../ngx-slider/ngx-slider.component';
import { CommuneStore } from '../../../stores/commune/commune.state';
import { ColorsetDefaultsService } from '../../../services/colorset/colorset-defaults.service';
import { ColorsetDropdownComponent } from '../../atoms/colorset-dropdown/colorset-dropdown.component';
import { DropdownModule } from 'primeng/dropdown';
import { HeaderComponent } from '../../atoms/header/header.component';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-configuration-chart-line',
  standalone: true,
  imports: [
    CheckboxModule,
    FormsModule,
    NgIf,
    NgxSliderComponent,
    ReactiveFormsModule,
    ColorsetDropdownComponent,
    DropdownModule,
    HeaderComponent,
    DividerModule,
  ],
  templateUrl: './configuration-chart-line.component.html',
  styleUrl: './configuration-chart-line.component.scss',
})
export class ConfigurationChartLineComponent implements OnInit {
  readonly communeStore = inject(CommuneStore);
  readonly globalStore = inject(GlobalsStore);
  readonly defaultsService = inject(ColorsetDefaultsService);
  form: FormGroup = new FormGroup({});
  initialized = false;
  items: MenuItem[] = [];
  activeCommune: Commune | null = null;
  lineConfiguration?: LineConfiguration;

  constructor(private fb: FormBuilder) {
    effect(() => {
      this.communeSetup();
    });
  }

  communeSetup() {
    if (!this.activeCommune) {
      this.activeCommune = this.globalStore.activeCommune();
      if (!this.activeCommune) return;
      if (!this.activeCommune.atlasConfig) {
        this.activeCommune.atlasConfig = this.communeStore.baseConfig();
      }
      this.lineConfiguration = this.activeCommune.atlasConfig.line;
    }
    if (this.activeCommune && !this.initialized) {
      this.initForm();
    }
  }

  ngOnInit() {
    this.communeSetup();
  }

  initForm() {
    this.form = this.fb.group({
      strokeWidth: [this.lineConfiguration?.dotSize || 1],
      colorset: [this.lineConfiguration?.colorset || undefined],
      dotSize: [this.lineConfiguration?.dotSize || 1],
      lineTension: [this.lineConfiguration?.lineTension || 0],
    });

    this.form.valueChanges.subscribe(() => {
      this.submit();
    });

    this.initialized = true;
  }

  submit() {
    if (!this.activeCommune) return;

    this.activeCommune.atlasConfig.line = {
      ...this.activeCommune.atlasConfig.line,
      ...this.form.value,
    };
    this.communeStore.update(this.activeCommune);
  }
}
